import { TrainerDto } from './trainer-dto.model';
import { LocationDto } from './location-dto.model';


export class EmployeeTrainingDto implements IEmployeeTrainingDto {
    id!: number;
    topic!: string | undefined;
    details!: string | undefined;
    trainer!: TrainerDto;
    fromDate!: Date;
    toDate!: Date;
    locationId!: number | undefined;
    location!: LocationDto;
    remarks!: string | undefined;
    isPaid!: boolean;
    attendeesId!: number[] | undefined;
    externalLocation!: string | undefined;

    constructor(data?: IEmployeeTrainingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.topic = _data["topic"];
            this.details = _data["details"];
            this.trainer = _data["trainer"] ? TrainerDto.fromJS(_data["trainer"]) : <any>undefined;
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.locationId = _data["locationId"];
            this.location = _data["location"] ? LocationDto.fromJS(_data["location"]) : <any>undefined;
            this.remarks = _data["remarks"];
            this.isPaid = _data["isPaid"];
            if (Array.isArray(_data["attendeesId"])) {
                this.attendeesId = [] as any;
                for (let item of _data["attendeesId"])
                    this.attendeesId!.push(item);
            }
            this.externalLocation = _data["externalLocation"];
        }
    }

    static fromJS(data: any): EmployeeTrainingDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeTrainingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["topic"] = this.topic;
        data["details"] = this.details;
        data["trainer"] = this.trainer ? this.trainer.toJSON() : <any>undefined;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["locationId"] = this.locationId;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["remarks"] = this.remarks;
        data["isPaid"] = this.isPaid;
        if (Array.isArray(this.attendeesId)) {
            data["attendeesId"] = [];
            for (let item of this.attendeesId)
                data["attendeesId"].push(item);
        }
        data["externalLocation"] = this.externalLocation;
        return data; 
    }
}

export interface IEmployeeTrainingDto {
    id: number;
    topic: string | undefined;
    details: string | undefined;
    trainer: TrainerDto;
    fromDate: Date;
    toDate: Date;
    locationId: number | undefined;
    location: LocationDto;
    remarks: string | undefined;
    isPaid: boolean;
    attendeesId: number[] | undefined;
    externalLocation: string | undefined;
}

